import React from 'react'
import CalculatorLabelAndTextDisplay from 'components/CalculatorLabelAndTextDisplay'

const FixedImagerSizeDisplay = ({ value }) => {
  return (
    <CalculatorLabelAndTextDisplay labelText='Imager' titleTag='Imager Size'>
      {value}
    </CalculatorLabelAndTextDisplay>
  )
}

export default FixedImagerSizeDisplay



// WEBPACK FOOTER //
// ./src/components/ImagerSizeContainer/FixedImagerSizeDisplay/index.js